import { render, staticRenderFns } from "./ProductionBatchSelector.vue?vue&type=template&id=6c053af3&scoped=true"
import script from "./ProductionBatchSelector.vue?vue&type=script&lang=js"
export * from "./ProductionBatchSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductionBatchSelector.vue?vue&type=style&index=0&id=6c053af3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c053af3",
  null
  
)

export default component.exports